import { unpurry } from "@suse-o11y/unpurry";
import { floor as floor_ } from "remeda";

export const floor = unpurry(floor_, 2);
